export default "__VITE_ASSET__BU97Fx0q__"